import axios from 'axios';

import { digestMessage, generateRandomId, getCookie } from '@/components/tracking_third_party/utils/fbcap.utils';
import { isConsentCategoryDisabled } from '@/tscapi/utils/consent';
import { Cookie } from '@/tscapi/utils/cookie';
import { getApiBaseUrl } from '@/tscapi/utils/utils';
declare global {
    interface Window {
        ttq: any;
        fbq: any;
        _fbq: any;
    }
}

type TiktokObject = {
    event_source: string;
    event_source_id: string;
    test_event_code?: string;
    data: {
        event: string;
        event_time: string;
        event_id?: string;
        user: {
            ttclid: string;
            email?: string;
            phone?: string;
            external_id?: string;
            ttp: string;
            ip: string;
            user_agent: string;
            locale: string;
        };
        page: {
            url: string;
            referrer: string;
        };
    }[];
};

document.addEventListener(
    'addPaymentInfoEvent',
    function () {
        ttAddPaymentInfoEvent();
    },
    false,
);

async function ttAddPaymentInfoEvent() {
    if (isConsentCategoryDisabled('targeting')) return;

    const url = getApiBaseUrl();
    const eventId = generateRandomId(15);
    const tiktokPayload = await generateTiktokObject(eventId);

    const axiosInstance = axios.create({
        baseURL: url,
        withCredentials: true,
        headers: {
            Authorization: 'Basic 567e407f-4bc5-463e-9c28-3ac2a2b333ec',
            'Content-Type': 'application/json',
        },
    });

    // Server-side event
    if (window.tscConfig?.CapiEnabled === 'true') {
        try {
            await axiosInstance.post('/tracking/v1/events/', tiktokPayload);
        } catch (error) {
            console.error('Error sending TT server event:', error?.response?.data || error.message);
        }
    }

    // Pixel event
    try {
        const pixelData = tiktokPayload[0].eventData.data[0];
        window.ttq.track('AddPaymentInfo', pixelData, { event_id: eventId });
    } catch (e) {
        console.error('Error sending TT pixel event');
    }
}

async function generateTiktokObject(eventId: string) {
    const ttclid = getCookie('ttclid');
    const ttp = getCookie('_ttp');
    const cookie = new Cookie();

    const userData: TiktokObject['data'][0]['user'] = {
        ttclid: ttclid ?? '',
        ttp: ttp ?? '',
        ip: cookie?.TscClientIP ?? '',
        user_agent: window.navigator.userAgent || '',
        locale: cookie?.Language?.replace('_', '-') ?? 'en-US',
    };

    if (cookie.UserAccessToken?.Token?.length > 0 && cookie.UserAccessToken.Edp > 0) {
        if (cookie.UserEmail) {
            userData.email = await digestMessage(cookie.UserEmail.toLowerCase());
        }
    }

    const eventData: TiktokObject = {
        event_source: 'web',
        event_source_id: 'C8AKQ23G5HF9JD2HK3O0',
        data: [
            {
                event: 'AddPaymentInfo',
                event_time: Math.floor(Date.now() / 1000).toString(),
                event_id: eventId,
                user: userData,
                page: {
                    url: window.location.href,
                    referrer: window.location.host,
                },
            },
        ],
    };

    if (window.tscConfig?.TiktokTestCode) {
        eventData.test_event_code = window.tscConfig.TiktokTestCode;
    }

    return [{ eventConsumer: 'tiktok', eventData }];
}
